import axios from 'axios';

// TODO: Need to figure out what are the best settings for request
export const api = axios.create({
  baseURL: process.env.API_URL,
  headers: {
    Accept: '*/*',
  },
  withCredentials: true,
});
